<template>
    <div>
        <a-layout style="background-color: #fff!important;">
            <a-layout-header>
                <div id="gueNav" class="paddingRight">
                    <a-row>
                        <a-col :span="2" @click="goHome" style="cursor:pointer;">
                            <img src="~@/assets/home/Logo.png" alt="" style="width: 136px" class="logo-icon">
                            <img src="~@/assets/icon/app-logo.png" alt="" style="width:32px;height:32px;" class="app-logo-icon">
                        </a-col>
                        <a-col :span="9" class="navList">
                            <a-row id="navList">
                                <a-col :span="4" style="margin-left: 59px;">
                                    <router-link to="/predictlist">{{$t('tab.PREDICT')}}</router-link> 
                                </a-col>
                                <a-col :span="4">
                                    <router-link to="/winners">{{$t('tab.WINNERS')}}</router-link>
                                </a-col>
                                <a-col :span="4" v-show="interLink == 1">
                                    <router-link to="/history">{{$t('tab.HISTORY')}}</router-link>
                                </a-col>
                                <a-col :span="4" v-show="interLink == 1">
                                    <router-link to="/account">{{$t('tab.ACCOUNT')}}</router-link>
                                </a-col>
                            </a-row>
                        </a-col>
                        <a-col :xl="{span:13}" :lg="{span:22}">
                            <div style="display: flex;color: #FFFFFF;float: right;">
                                <a-popover
                                    title=""
                                    trigger="click"
                                    :visible="clicked"
                                    @visibleChange="handleClickChange"
                                    >
                                        <div slot="content">
                                            <div class="f_c_box1" v-if="linkAry.length>0">
                                                <div class="fox_region" @click="linkChange(i)" v-for="(i,j) in linkAry" :key="j">
                                                    <img :src="require(`./assets/home/${i.id}.jpg`)" alt="" class="foxIcon">  {{i.name}}
                                                </div> 
                                            </div>
                                        </div>
                                        <a-button class="connect" style="border: 0;margin-right: 24px;">
                                            <div v-if="chainName == undefined && account != undefined">
                                                <img src="~@/assets/home/failed.jpg" alt="" style="width: 32px;margin-right: 10px;"> Unsupported
                                                <a-icon type="down" :style="{ color: '#FFFFFF!important',marginTop:'13px',float:'right' }" class="poloName" />
                                            </div>
                                            <div v-else-if="chainName == undefined && account == undefined" style="width: 32px;margin-right: 10px;">
                                                <img :src="require(`./assets/home/${connectIcon}.jpg`)" alt=""> {{connetName}} 
                                                <a-icon type="down" :style="{ color: '#FFFFFF!important',marginTop:'13px',float:'right' }" class="poloName" />
                                            </div>
                                            <div v-else>
                                                <img :src="require(`./assets/home/${chainId}.jpg`)" alt="" style="width: 32px;margin-right: 10px;"> {{connetName}} 
                                                <a-icon type="down" :style="{ color: '#FFFFFF!important',marginTop:'13px',float:'right' }" class="poloName" />
                                            </div>
                                        </a-button>
                                </a-popover>
                                <div v-if="interLink == 1">
                                    <div class="connect" style="text-align: center;">
                                        <span class="status"></span> {{accountName}}
                                    </div>
                                </div>
                                <a-tooltip v-else>
                                    <template slot="title">
                                        <div class="f_c_box">
                                            <div class="fox_region" @click="connetWallet(1)">
                                                <img src="~@/assets/nav/fox.png" alt="" class="foxIcon">  Metamask 
                                            </div>
                                        </div>
                                    </template>
                                    <a-button class="connect_btn">Connect Wallet</a-button>
                                    <a-button class="app_connect_btn">Connect</a-button>
                                </a-tooltip>
                                <!-- <div v-else>
                                    
                                </div> -->
                                <div style="text-align: right;" class="langChange">
                                    <!-- <img src="~@/assets/home/help.png" alt="" style="width:22px;height:23px;cursor: pointer;margin: 0 45px;" @click="goGuess">  -->
                                    <a-tooltip>
                                        <template slot="title">
                                            <div class="l_c_box">
                                                <div class="lang_region"  @click="changeLocale(null)">
                                                    English
                                                </div>
                                            </div>
                                        </template>
                                        <img src="~@/assets/home/language.png" alt="" style="width:22px;height:22px;cursor:pointer;">
                                    </a-tooltip>
                                </div>
                                <a-icon type="menu" two-tone-color="#fff" :style="{ fontSize: '24px' }" @click="visible=true" class="menuIcon" />
                            </div>
                        </a-col>
                    </a-row>
                </div>
            </a-layout-header>
            <a-layout-content id="commenContent">
                <router-view />
            </a-layout-content>
        </a-layout>
        <a-drawer
        title=""
        :placement="placement"
        :closable="false"
        :visible="visible"
        @close="visible=false" width="60%" :drawerStyle="{background:'#131419'}"
        >
            <div class="menuModel">
                <ul class="menuUl"> 
                    <li :class="navIndex==1?'active':''" @click="appGoPage(1)">
                        {{$t('tab.PREDICT')}}
                    </li>
                    <li :class="navIndex==2?'active':''" @click="appGoPage(2)">
                        {{$t('tab.WINNERS')}}
                    </li>
                    <li :class="navIndex==3?'active':''" @click="appGoPage(3)">
                        {{$t('tab.HISTORY')}}
                    </li>
                    <li :class="navIndex==4?'active':''" @click="appGoPage(4)">
                        {{$t('tab.ACCOUNT')}}
                    </li>
                </ul>
            </div>
            <div class="bottomModel">
                <!-- <div class="langPart"><img src="~@/assets/home/Frame_.png" class="icon" @click="goGuess">help</div> -->
                <div :class="['langPart',langShow==true?'clickPart':'']"> 
                    <div class="langbox" v-if="langShow">
                        <div class="active">English</div>
                        <div style="margin-top: 16px;">中文</div>
                    </div>
                    <div class="" @click="langShow=!langShow">
                        <img src="~@/assets/home/language.png" class="icon" style="margin-right: 7px;">language
                    </div>
                </div>
            </div>
        </a-drawer>
    </div>
</template>

<script>
import { toRefs } from "vue";
import { useWallet } from "./hooks/useWallet";
import {getChains } from 'guesslot-js';

var { account, chainId, chainName,connect, disconnect, usePool, useSubgraph, useStats, useGToken } = toRefs(useWallet);
const { switchChain } = useWallet;

const EN = 'en-us'
const ZH = 'zh-cn'
export default {
  data() {
    return {
        navIndex:1,
        langShow:false,
        name:'',
        predict:{
            asset:{
                name:'',
                time:''
            },
            settleTime:'',
            prize:'',
            stakeToken:{
                balance:'',
                symbol:''
            }
        },
        interLink:0,
        urlName:'',
        locale: null,
        linkAry:[],
        connetName:'Polygon',
        connectIcon:'connect',
        chainName:chainName,
        chainId:chainId,
        clicked:false,
        account,
        accountName:'',
        placement:'right',
        visible:false,

        // connetName:'Polygon' || chainName==''?'Unsupported' : connetName,
        // connectIcon:'connect' || chainName==''?'failed' : connectIcon
    }
  },
  created(){
    
  },
  beforeMount(){
     
  },
  async mounted(){
    // console.log(getChains(),'getchain');
    // console.log(this.chainName,'chainName')
    // console.log(this.account,'account');
    this.linkAry = getChains();
    this.linkChange(this.linkAry[0]);
    if (!useWallet.account){
        this.connetWallet();
    }else{
        await useWallet.connect();
    }
  },
  watch:{
    chainName:function(newValue,oldValue){
       console.log(newValue,'chainNameNEw');
       if(newValue == undefined){
            
       }else{
        this.connetName = newValue;
        this.connectIcon = newValue;
       }
    },
    account:function(newValue,oldValue){
        console.log(newValue,'newAccount');
        if(newValue){
            this.accountName = newValue.slice(0,4) + '...' + newValue.substr((newValue.length)-4);
        }else{
            this.accountName = newValue
        }
    }
  },
  methods: {
    appGoPage(e){
        this.navIndex = e;
        switch(e){
            case 1:
                this.$router.push({path:'/predictlist'});
                break;
            case 2:
                this.$router.push({path:'/winners'});
                break;
            case 3:
                this.$router.push({path:'/history'});
                break;
            default:
                this.$router.push({path:'/account'});
                break;
        }
        this.visible = false;
    },
    connetWallet(e){
        localStorage.setItem('userInfo','');
        useWallet.connect("MetaMask").then(() => {
            this.interLink = 1;
            this.$store.commit('USER_INFO',useWallet);//请求回来后，把用户信息存储到VUEX里
            let firstName = account.value.slice(0,4);
            let lastName = account.value.substr((account.value.length)-4);
            this.accountName = firstName+'...'+lastName;
            if(e == 1){
                //刷新页面
                location.reload();
            }
        })
        .catch(data => {
            //链接失败后 清除缓存
            localStorage.setItem('userInfo','');
          //  console.log("链接失败", data);
        });
        
    },
    goHome(){
        this.$router.push({path:'/'});
    },
    changeLocale(e){
        if(e == null){
            this.$i18n.locale = EN
            localStorage.setItem('lang','en-us')
            location.reload();
        }else{
            this.$i18n.locale = ZH
            localStorage.setItem('lang','zh-cn')
            location.reload();
        }
    },
    goGuess(){
        window.open('https://docs.guesslot.com/');
    },
    linkChange(e){
       console.log(e);
       // console.log(this.chainName,'chainName')
        this.connetName = e.name;
        this.connectIcon = e.id;
        this.clicked = false;
        switchChain(e.id).then(()=>{
        })
        .catch((error) => {
            console.log(error,'changeError');
            //异常
            this.connetName = 'Unsupported';
            this.connectIcon = 'failed';
        });
    },
    handleClickChange(visible) {
      this.clicked = visible;
    },
  }
};
</script>

<style lang="scss" scoped>
.ant-layout-header{
    height: 84px!important;
    line-height: 84px;
    background: #131419;
    padding: 0!important;
}
/* 针对所有移动设备的通用样式 */
@media only screen and (max-width: 1024px) {
    /* 样式规则 */
    /* #appGueNav{display: inline-block;width: 100%;height: 100%;} */
    /* #gueNav{display: none;} */
    .paddingRight{padding: 0 20px;}
    .langChange{display: none;}
    .poloName{display: none;}
    .menuIcon{display: inline-block;margin-left: 20px;margin-top: 28px;}
    .appHeader{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 12px;
        padding: 0 20px;
        .userName{
            margin: 0 24px;
            padding: 10px 20px;
            background: #1F2025;
        }
    }
    .appPolygon{
        width: 117px;
    }
    .connect{
        width: 110px;
        height: 42px;
        background: #1F2025;
        border-radius: 4px;
        text-align: left;
        line-height: 42px;
        color: #fff;
        margin-top: 20px;
        img{
            width: 20px;
            margin-right: 5px;
            vertical-align: middle;
        }
    }
    .navList{display: none;}
    .app-logo-icon{display: inline-block;}
    .logo-icon{display: none;}
    .connect_btn{
        display: none;
    }
    .app_connect_btn{
        width: 110px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        background: linear-gradient(90deg, #C93393 0%, #605FFA 100%);
        border:0;
        border-radius: 4px;
        display: inline-block;
        font-family: 'Medium'
    }
    .f_c_box1{
        width: 117px;
        padding:14px 0;
        font-size: 14px;
        .foxIcon{
            width: 20px;
            margin-right: 10px;
            vertical-align: sub;
        }
        .fox_region{
            width: 100%;
            cursor: pointer;
            padding: 2px 15px;
            color: #F1F2F2;
        }
        .fox_region:hover{
            background: #1F2025
        }
    }
    .f_c_box{
        width: 110px;
        background: #131419;
        padding: 10px 4px;
        text-align: center;
        border-radius: 4px;
        margin-top: -18px;
        .foxIcon{
            width: 20px;
            margin-right: 8px;
        }
        .fox_region{
            width: 100%;
            cursor: pointer;
            padding: 2px 0;
            color: #F1F2F2;
        }
        .fox_region:hover{
            background: #1F2025
        }
    }
    .status{
        width: 10px;
        height: 10px;
        background: #00A856;
        border-radius: 50%;
        margin-top: 5px;
        display: inline-block;
        margin-right: 5px;
    }
}
@media only screen and (min-width: 1028px) {
    /* 样式规则 */
    .app-logo-icon{display: none;}
    .logo-icon{display: inline-block;}
    .paddingRight{padding: 0 88px;}
    .langChange{display: block;}
    .poloName{display: inline-block;}
    .menuIcon{display: none;}
    #appGueNav{
        /* display: none; */
    }
    .appPolygon{
        width: 200px;
    }
    .navList{display: block;}
    .connect_btn{
        width: 175px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        background: linear-gradient(90deg, #C93393 0%, #605FFA 100%);
        border:0;
        border-radius: 4px;
        display: inline-block;
        font-family: 'Medium'
    }
    .app_connect_btn{display: none;font-family: 'Medium'}
    .f_c_box1{
        width: 200px;
        padding:14px 0;
        font-size: 14px;
        .foxIcon{
            width: 29px;
            margin-right: 15px;
        }
        .fox_region{
            width: 100%;
            cursor: pointer;
            padding: 2px 15px;
            color: #F1F2F2;
        }
        .fox_region:hover{
            background: #1F2025
        }
    }
    .f_c_box{
        width: 175px;
        background: #131419;
        padding: 14px 0;
        text-align: center;
        border-radius: 4px;
        margin-top: 20px;
        .foxIcon{
            width: 26px;
            height: 24px;
            margin-right: 16px;
        }
        .fox_region{
            width: 100%;
            cursor: pointer;
            padding: 2px 0;
            color: #F1F2F2;
        }
        .fox_region:hover{
            background: #1F2025
        }
    }
    .connect{
        width: 200px;
        height: 42px;
        background: #1F2025;
        border-radius: 4px;
        text-align: left;
        line-height: 42px;
        color: #fff;
        margin-top: 20px;
        font-family: 'Medium'
        img{
            width: 29px;
            margin-right: 10px;
            vertical-align: middle;
        }
    }
    .status{
        width: 10px;
        height: 10px;
        background: #00A856;
        border-radius: 50%;
        margin-top: 5px;
        display: inline-block;
        margin-right: 16px;
    }
}

#gueNav{
    width: 100%;
    height: 83px;
    background: #131419;
    line-height: 83px;
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
}
.menuModel{
    background: #131419;
    padding: 0 13px;
    border-radius: 4px;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    .menuUl{
        margin-top: 90px;
        padding: 0 0 30px 0;
        border-bottom: 1px solid rgba(217,217,217,0.1);
        li{
            padding: 30px 0;
            list-style: none;
            a{
                color: #fff;
            }
        }
        .active{
            background: rgba(200,52,149,0.1);
            border-radius: 8px;
            font-weight: 500;
            font-size: 16px;
            a{
                color: #C83495;
            }
        }
    }
}
.bottomModel{
    position: absolute;
    bottom: 58px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #F1F2F2;
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    padding: 0 10px;
    .icon{
        width: 13px;height: 13px;margin-right: 12px;
    }
    .langPart{
        padding: 10px;
        flex: 1;
        align-self: flex-end;
    }
    .clickPart{
        background: rgba(217,217,217,0.06);
        border-radius: 4px;
        width: 112px;
        position: relative;
        .langbox{
            border-bottom: 1px solid rgba(217,217,217,0.1);
            text-align: center;
            padding: 16px 0;
            margin-bottom: 11px;
            .active{
                color: #C83495;
                font-weight: 500;
            }
        }
        .lang{
            position: absolute;
            bottom: 10px;
            left: 14px;
        }
    }
}
.navBgColor{
    /* background: #344BCA; */
}
.navHomeBgColor{
    background: linear-gradient(to left, #7B98FD 0%, #3763FD 100%);
}
.logoTxt{
  font-size: 24px;
  font-family: 'Bold';
  color: #FACC03;
}

#navList a{
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
}

::v-deep .router-link-exact-active,::v-deep .router-link-active{
    color: #C63596!important;
}
::v-deep .router-link-exact-active::after,::v-deep .router-link-active::after {
    content: '';
    width: 28px;
    height: 2px;
    display: block;
    margin-left: 13px;
    margin-top: -18px;
    border-bottom: 3px solid #C63596;
}

#mainnet{
    width: 250px;
    height: 36px;
    background: rgba(24, 117, 240, 0);
    border-radius: 5px;
    border: 1px solid #FFFFFF;
    color: #FFFFFF;
    font-family: 'Regular';
    font-size: 14px;
    padding: 7px 10px;
    float: right;
    margin-right: 28px;
    margin-top: 35px;
}
.netbtn{
    width: 80px;
    height: 20px;
    border-radius: 10px;
    border: 1px solid #FFFFFF;
    line-height: 16px;
    text-align: center;
}
#language{
    width:22px!important;
    height: 22px;
    background: url('~@/assets/home/language.png') no-repeat;
    border:0;
    background-size: 100% 100%;
}
.langChoice{
    width: 100px;
    height: 86px;
    box-shadow: 0px 0px 20px 0px rgba(150, 157, 171, 0.1);
    border-radius: 12px;
    position: absolute;
    top: 76px;
    right: 23px;
    text-align: center;
}
.langH{
    height: 43px;
    line-height: 43px;
    cursor: pointer;
}
.ellipsis{
    display: inline-block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow:ellipsis;
    width: 120px;
    line-height: 20px;
}
.interlink{
    width: 250px;
    height: 36px;
    background: rgba(24, 117, 240, 0);
    border-radius: 5px;
    border: 1px solid #FFFFFF;
    font-size: 16px;
    font-family: 'Bold';
    color: #FFFFFF;
}

#c_success_m{
    width: 175px;
    padding: 14px 0;
    line-height: 64px;
    color: #fff;
    background: #131419;
    border-radius: 4px;
}
#bulletBox{
    width: 112px;
    height: 90px;
    background: #131419;
    border-radius: 4px;
    color: #F1F2F2;
    font-weight: 500;
}
.l_c_box{
    width: 112px;
    padding: 5px 0;
    background: #131419;
    border-radius: 4px;
    text-align: center;
    .lang_region{
        width: 100%;
        cursor: pointer;
        padding: 6px 0;
        color: #F1F2F2;
    }
    .lang_region:hover{
        background: #1F2025;
        color: #C83495;
    }
}

</style>
